import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import Logo from "../components/Logo";
import TechnicianDashboard from "./TechnicianDashboard";
import AdminDashboard from "./AdminDashboard";

/* Role-aware dashboard: server-verified session via AuthProvider (/auth/me). */
export default function Dashboard() {
  const { user, loading } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const passed = location.state?.user;
  const current = user || passed;

  useEffect(() => {
    if (!loading && !current) navigate("/login", { replace: true });
  }, [loading, current, navigate]);

  if (!current) {
    return (
      <div data-testid="dashboard-loading" className="min-h-screen flex flex-col items-center justify-center gap-5">
        <Logo />
        <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-slate-400">Loading…</p>
      </div>
    );
  }
  return current.role === "admin" ? <AdminDashboard /> : <TechnicianDashboard />;
}
